module.exports = __webpack_public_path__ + "img/2-ExitusCreditUX_UI.17fb3c93.jpg";